<div *ngIf="kioskModel" class="animated fadeIn">

    <table-component (onAdd)="onAdd()"
                     (onEdit)="onEdit($event)"
                     (onRemove)="onRemove($event)"></table-component>

</div>

<kiosk-model-questions-edit-component></kiosk-model-questions-edit-component>
